import type { Modifier } from "@dnd-kit/core";

/**
 * Constrains a drag to the vertical axis (zeroes the horizontal translation),
 * so dragging a row sideways can't widen/scroll the panel. Equivalent to
 * `@dnd-kit/modifiers`' restrictToVerticalAxis, inlined to avoid the extra dep.
 */
export const restrictToVerticalAxis: Modifier = ({ transform }) => ({
  ...transform,
  x: 0,
});
